'use strict';


const Head = require('../../font/table_head');


class LvHead extends Head {
  constructor(font) {
    super(font);
  }

  kern_ref() {
    const f = this.font;

    if (!f.hasKerning()) {
      return {
        scale:   '0',
        dsc:     'NULL',
        classes: '0'
      };
    }

    if (!f.kern.should_use_format3()) {
      return {
        scale: `${Math.round(f.kerningScale * 16)}`,
        dsc: '&kern_pairs',
        classes: '0'
      };
    }

    return {
      scale: `${Math.round(f.kerningScale * 16)}`,
      dsc: '&kern_classes',
      classes: '1'
    };
  }

  toLVGL() {
    const f = this.font;
    const kern = this.kern_ref();
    const subpixels = (f.subpixels_mode === 0) ? 'NG_FONT_SUBPX_NONE' :
      (f.subpixels_mode === 1) ? 'NG_FONT_SUBPX_HOR' : 'NG_FONT_SUBPX_VER';

    return `

static ng_font_fmt_txt_dsc_t font_dsc = {
    .glyph_bitmap = gylph_bitmap,
    .glyph_dsc = glyph_dsc,
    .cmaps = cmaps,
    .kern_dsc = ${kern.dsc},
    .kern_scale = ${kern.scale},
    .cmap_num = ${f.cmap.toBin().readUInt32LE(8)},
    .bpp = ${f.opts.bpp},
    .kern_classes = ${kern.classes},
    .bitmap_format = ${f.glyf.getCompressionCode()}
};


ng_font_t ${f.font_name} = {
    .get_glyph_dsc = ng_font_get_glyph_dsc_fmt_txt,    
    .get_glyph_bitmap = ng_font_get_bitmap_fmt_txt,    
    .line_height = ${f.src.ascent - f.src.descent},          
    .base_line = ${-f.src.descent},             
#if !(NGGL_VERSION_MAJOR == 6 && NGGL_VERSION_MINOR == 0)
    .subpx = ${subpixels},
#endif
#if NG_VERSION_CHECK(7, 4, 0)
    .underline_position = ${f.src.underlinePosition},
    .underline_thickness = ${f.src.underlineThickness},
#endif
    .dsc = &font_dsc           
};
`.trim();
  }
}


module.exports = LvHead;
